import apiRoutes from './apiRoutes'

export const ROUTES = { ...apiRoutes }

export const STORAGE_KEYS = {
  SELECTED_LOCALE: 'selectedLocale',
}

export const LOCALES = { DE: 'de', EN: 'en', PL: 'pl', UA: 'ua' }
